<template lang="pug" src="./forms.pug"></template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        loading: false,
        removeModal: false,
        activeFormId: null
    }),
    computed: {
        ...mapState({
            items: state => state.forms.items,
            pagination: state => state.forms.pagination
        }),
        headers() {
            return ['id', 'name', 'description', 'count', 'createdAt', 'updatedAt', 'actions'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Forms.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    created() {
        this.loadItems();
    },
    methods: {
        loadItems(page = 1) {
            if (this.loading) return;

            this.loading = true;

            this.$store.dispatch('forms/getItems', Object.assign({}, {
                page
            })).then(() => {
                this.$nextTick(() => this.loading = false);
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        },
        openRemoveModal(formId) {
            this.removeModal = true;
            this.activeFormId = formId;
        },
        async remove() {
            this.removeModal = false;
            await this.$store.dispatch('forms/destroy', this.activeFormId);
            await this.loadItems(this.pagination.page);
        }
    }
};
</script>
